export const snakeToTitle = (str: string) =>
  str.charAt(0).toUpperCase() +
  str.slice(1).replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace('-', ' ')
      .replace('_', ' '),
  );